import moment from 'moment';

export const calendarCutOffMissed = {
	cut_offs: [
		{
			type: 'BACS',
			start: '0',
			end: '61800',
			next_available_date: moment().add(4, 'day').format('YYYY-MM-DD'),
		},
		{
			type: 'SO',
			start: '0',
			end: '57600',
			next_available_date: moment().add(4, 'day').format('YYYY-MM-DD'),
		},
		{
			type: 'CHAPS',
			start: '0',
			end: '61200',
			next_available_date: moment().add(4, 'day').format('YYYY-MM-DD'),
		},
	],
	current_time: '2018-11-23 10:24:57.449',
};

export const getCalendarStub = (requestBody, apiUrl) => {
	// The CHAPS API call only returns submission dates
	const isChapsCalenderRequest = apiUrl.indexOf('chaps') > -1;
	const chapsDate = moment();
	// mimick time of day cut-off
	if (chapsDate.hour() >= 15) {
		if (chapsDate.isoWeekday() >= 5) {
			chapsDate.add(8 - chapsDate.weekday(), 'days');
		} else {
			chapsDate.add(1, 'day');
		}
	}

	const days30 = moment().add(30, 'days');
	const chapsDates = [];

	while (chapsDate <= days30) {
		if (![0, 6].includes(chapsDate.day())) {
			const settlement = chapsDate.clone().add(4, 'day').format('YYYY-MM-DD');

			chapsDates.push({
				submission: chapsDate.format('YYYY-MM-DD'),
				...(!isChapsCalenderRequest && { settlement }),
			});
		}
		chapsDate.add(1, 'day');
	}

	return {
		dates: chapsDates,
	};
};

export const oldcalendarStub = {
	dates: [
		{ submission: '2018-11-01', settlement: '2018-11-04' },
		{ submission: '2018-11-02', settlement: '2018-11-05' },
		{ submission: '2018-11-03', settlement: '2018-11-06' },
	],
};
